module.exports = __webpack_public_path__ + "img/战争.8b73f15d.png";